export function getFileExplorerQueryKey(id?: number) {
  return id ? `filetree-folder-${id}` : 'filetree-root';
}
